export const mobileOnlyFeature = (isMobile: boolean, feature: boolean) =>
  isMobile && feature;
